import { useEffect } from "react";
import { App as CapacitorApp } from "@capacitor/app";
import { isNativeApp } from "../../lib/platform/native";

/**
 * NativeBackButtonBridge — o botão/gesto de voltar do ANDROID (BUG-172).
 *
 * Sem listener `backButton` registrado, o `@capacitor/app` decide sozinho:
 * `webView.goBack()` quando `canGoBack()` e, quando NÃO pode (raiz do app),
 * **nada** — o `OnBackPressedCallback` consome o evento e o usuário fica
 * preso, sem nem minimizar (medido no AppPlugin.java 8.1.1, não na doc). Com
 * o listener, quem decide é o app: história interna volta página (o mesmo
 * `popstate` que o React Router já trata na web), raiz sai do app — o
 * comportamento Android idiomático.
 *
 * O gesto de arrastar da borda no Android 10+ É o back do sistema, então este
 * listener é também a metade Android do swipe-back (a metade iOS é o
 * `allowsBackForwardNavigationGestures` no AppDelegate).
 *
 * Web e iOS: o evento `backButton` não existe — e o guard `isNativeApp()` nem
 * registra o listener fora do nativo. Import ESTÁTICO do plugin de propósito
 * (o `import()` dinâmico pendurou no WKWebView nos builds 41/42), e o
 * unsubscribe devolvido é plano, nunca o handle do plugin (o Proxy do
 * `registerPlugin` é o thenable falso do BUG-154).
 */
export function NativeBackButtonBridge() {
  useEffect(() => {
    if (!isNativeApp()) return;

    let removed = false;
    let removeListener: (() => void) | null = null;

    CapacitorApp.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        void CapacitorApp.exitApp();
      }
    })
      .then((handle) => {
        // O cleanup pode ter rodado antes de a promise assentar (StrictMode
        // monta-desmonta-monta): remover aqui evita listener duplicado vivo.
        if (removed) void handle.remove();
        else removeListener = () => void handle.remove();
      })
      .catch((err) => {
        // Sem listener o Android degrada pro default do plugin (goBack quando
        // pode) — pior que o desenhado, melhor que um app quebrado.
        console.warn("[Lura] backButton nativo indisponível.", err);
      });

    return () => {
      removed = true;
      removeListener?.();
    };
  }, []);

  return null;
}
